import React, { useState } from "react";
import { Dropdown } from "../../../components/ui/dropdown/Dropdown";
import { DropdownItem } from "../../../components/ui/dropdown/DropdownItem";

interface FilterDropDownProps {
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
}

const FilterDropDown: React.FC<FilterDropDownProps> = ({
  selectedFilters,
  setSelectedFilters,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  function toggleDropdown() {
    setIsOpen(!isOpen);
  }

  function closeDropdown() {
    setIsOpen(false);
  }

  function handleFilterSelection(value: string) {
    if (!selectedFilters.includes(value)) {
      setSelectedFilters([...selectedFilters, value]);
    }
    closeDropdown();
  }

  return (
    <div className="flex items-center w-full gap-4">
      {/* Dropdown Button */}
      <div className="relative">
        <button
          onClick={toggleDropdown}
          className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium text-[#ffffed] rounded-lg bg-[#142900] hover:bg-[#e1ffb4] hover:text-[#142900]"
        >
          Filter Options
          <svg
            className={`duration-200 ease-in-out stroke-current ${
              isOpen ? "rotate-180" : ""
            }`}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.79199 7.396L10.0003 12.6043L15.2087 7.396"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
          <Dropdown
            isOpen={isOpen}
            onClose={closeDropdown}
            className="absolute left-0 top-full z-40 mt-2 w-full min-w-[250px] max-h-80 overflow-y-auto rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-[#1E2635]"
          >
            <ul className="flex flex-col gap-1">
              {[
                "Name",
                "Product Type",
                "Venue",
                "Display",
                "Code",
                "Supplier",
                "Category",
                "Sub-Category",
                "Single-item Barcode Number",
                "Packaging Barcode Number",
                "Recipe",
                "Cooked Product",
                "Star Item",
                "Available for Franchise",
                "Ingredient Name for Labels",
                "Linked to Supplier",
                "Priced Per Kg",
                "GST",
                "Temperature on Delivery",
                "Expiry Tracking",
                "Bulk Ingredient",
                "Yield Monitoring",
                "Include in Central Inventory",
                "Packaging Barcode",
              ].map((filter) => (
                <li key={filter}>
                  <DropdownItem
                    onItemClick={() => handleFilterSelection(filter)}
                    className="flex rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-[#ffffa3] dark:text-gray-300 dark:hover:bg-white/5"
                  >
                    {filter}
                  </DropdownItem>
                </li>
              ))}
            </ul>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default FilterDropDown;